import React from 'react';

const Services = () => {
    const services = [
        {
            image: 'https://i.ibb.co/fFKRQQT/0-ZEPJs-ASf-B2z7hi-0.png',
            name:'Full-stack development'
        },
        {
            image: 'https://i.ibb.co/hM68xY5/images-1.png',
            name:'Front-end development'
        },
        {
            image: 'https://i.ibb.co/7KK0p7V/images-4.jpg',
            name:'Back-end development'
        }
    ]
    return (
        <div className=' md:mb-0 md:mt-20 md:mx-24 pb-10  mt-16' id='services'>
            <div>
                <h1 className='header text-7xl mx-auto'>Work</h1>
                <h2 className='about font-extrabold md:text-7xl text-4xl -mt-3 md:-mt-0'>SERVICES</h2>
                <p className='mx-auto mt-5 features'></p>
            </div>
            <div className='md:flex md:mx-28 my-10 gap-10 '>
                {
                    services.map(service => <div key={service.image} className='project' data-aos="zoom-in-right">
                        <img src={service.image} alt="" className='md:h-[200px] md:w-[500px] w-full'/>
                        <h1 className='service mb-10 md:my-4 p-2'>{service.name}</h1>
                    </div>)
                }
            </div>
        </div>
    );
};

export default Services;